module.exports = __webpack_public_path__ + "img/oval.1e8546c0.svg";